<template lang="pug">
  div#dot-button.more-btn-container(
    @click.prevent="handleBtnClick"
  )
    .more-text-icon(:class="{'is-new': isNew}") 更多
    //- 气泡内容
    .bubble-container(v-if="isShowBubble" @touchmove.prevent)
      //- 顶部三角形
      img.bubble-arrow(src="https://m.hellobike.com/e7bd6702_Slice%2019.png")
      //- 主体内容区
      .bubble-body
        template(v-for="item in DOT_CONFIG_LIST")
          .bubble-item(@click="handleItemClick(item)")
            span.bubble-text {{ item.name }}
            img.arrow-icon(src="data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 3L9 7L5 11' stroke='%235A6066' stroke-width='1'/%3E%3C/svg%3E" alt="")

</template>

<script>
import { jumpUrl } from '@/utils/tools';
import config from '@/const/config';
import { DOT_CONFIG_LIST, WIDGET_SOURCE, WIDGET_TEMPLATE_ID } from '../consts';
import { addWidget } from '../common/bridge';
import { queryUserWidgetStatus } from '../common/helper';
import SPM from '../common/spm';

export default {
  name: 'DotBtn',
  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 配置列表（动态，可能追加签到神器入口）
      DOT_CONFIG_LIST: [...DOT_CONFIG_LIST],
      // 气泡是否显示
      isShowBubble: false,
    };
  },
  inject: ['getStyleVersion'],
  mounted() {
    SPM.clickButton({
      moduleId: 'platform_defaultOrderDeduction',
      contentId: 'platform_defaultOrderDeduction',
      businessInfo: {},
    });
    // 初始化查询小组件状态
    this.checkWidgetStatus();
    // 监听页面可见性变化，重新判断小组件状态
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    // 滚动和点击事件监听隐藏气泡
    window.addEventListener('scroll', () => {
      if (this.isShowBubble) {
        this.isShowBubble = false;
      }
    });
    window.addEventListener('click', (e) => {
      const excludedButton = document.getElementById('dot-button');
      if (excludedButton && excludedButton.contains(e.target)) {
        return;
      }
      if (this.isShowBubble) {
        this.isShowBubble = false;
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
  methods: {
    // 查询小组件状态，决定是否展示签到神器入口
    async checkWidgetStatus() {
      // 先移除已有的签到神器入口，保证幂等
      this.DOT_CONFIG_LIST = this.DOT_CONFIG_LIST.filter((item) => !item.isWidget);
      const { canAddComponent } = await queryUserWidgetStatus();
      if (canAddComponent) {
        this.DOT_CONFIG_LIST.unshift({ name: '签到神器', isWidget: true });
      }
    },
    // 点击签到神器，调用addWidget添加小组件
    async handleAddWidget() {
      await addWidget({ templateId: WIDGET_TEMPLATE_ID, source: WIDGET_SOURCE });
      // 客户端反馈结果不一定准确，重新查询后端接口判断入口显隐
      this.checkWidgetStatus();
    },
    // 页面可见性变化时重新判断小组件状态
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        this.checkWidgetStatus();
      }
    },
    // 点击按钮
    handleBtnClick() {
      this.isShowBubble = !this.isShowBubble;
      SPM.clickButton({
        buttonName: 'platform_defaultOrderDeduction',
        businessInfo: {},
      });
      SPM.moduleExpose({
        moduleId: 'platform_more_rulesDescription',
        contentId: 'platform_more_rulesDescription',
        businessInfo: {},
      });
      SPM.moduleExpose({
        moduleId: 'platform_moreFeedback',
        contentId: 'platform_moreFeedback',
        businessInfo: {},
      });
      // 签到神器入口曝光埋点（动态入口）
      const widgetItem = this.DOT_CONFIG_LIST.find((item) => item.isWidget);
      if (widgetItem) {
        SPM.moduleExpose({
          moduleId: 'platform_entrance',
          contentId: 'platform_entrance',
          businessInfo: {
            extra: {
              action: 'hellobike/platform/welfare',
              method: 'addWidget',
              templateId: WIDGET_TEMPLATE_ID,
              source: WIDGET_SOURCE,
            },
            fuliwidgetentrance: 2,
            text: widgetItem.name,
          },
        });
      }
    },
    // 点击列表项
    handleItemClick(item) {
      // 签到神器入口，调用addWidget
      if (item.isWidget) {
        SPM.clickButton({
          buttonName: 'platform_entrance',
          businessInfo: {
            extra: {
              action: 'hellobike/platform/welfare',
              method: 'addWidget',
              templateId: WIDGET_TEMPLATE_ID,
              source: WIDGET_SOURCE,
            },
            fuliwidgetentrance: 2,
            text: item.name,
          },
        });
        this.handleAddWidget();
        return;
      }

      if (item.name === '默认抵扣订单') {
        const envPrefix = config.env !== 'pro' ? `${config.env}/` : '';
        jumpUrl(`https://m.hellobike.com/AppPlatformH5/${envPrefix}latest/index.html#/welfare/bonus-rule`);
        return;
      }

      if (item.name === '规则说明') {
        SPM.clickButton({
          buttonName: 'platform_more_rulesDescription',
          businessInfo: {},
        });
      }
      if (item.name === '反馈建议') {
        SPM.clickButton({
          buttonName: 'platform_moreFeedback',
          businessInfo: {},
        });
      }

      const { linkUrl = '' } = item || {};
      jumpUrl(linkUrl);
    },
  },
};
</script>

<style lang="less" scoped>
.more-btn-container {
  position: relative;

  .more-text-icon {
    margin-top: 0.02rem;
    font-family: PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 400;
    line-height: 1.333;
    color: #fff;

    &.is-new {
      color: #454545;
    }
  }

  .bubble-container {
    position: absolute;
    top: 0.28rem;
    right: -0.03rem;
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    z-index: 10000;
    filter: drop-shadow(0 0.06rem 0.12rem rgba(0, 0, 0, 0.12));

    /* 顶部三角形 */
    .bubble-arrow {
      width: 0.16rem;
      height: 0.08rem;
      margin-right: 0.12rem;
      margin-bottom: -0.01rem;
    }

    /* 主体内容区 */
    .bubble-body {
      background: #fff;
      border-radius: 0.12rem;
      padding: 0.16rem;
      display: flex;
      flex-direction: column;
      gap: 0.16rem;
    }

    .bubble-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 1.08rem;
      height: 0.17rem;
      cursor: pointer;

      .bubble-text {
        font-family: PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 600;
        line-height: 1.4;
        color: #000;
      }

      .arrow-icon {
        width: 0.14rem;
        height: 0.14rem;
        flex-shrink: 0;
      }
    }
  }
}
</style>
